/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Status_MaintenanceInputs */

const vi_vehicle_status_maintenance = /** @type {(inputs: Vehicle_Status_MaintenanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảo trì`)
};

/**

* @param {Vehicle_Status_MaintenanceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_status_maintenance = /** @type {((inputs?: Vehicle_Status_MaintenanceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Status_MaintenanceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_status_maintenance(inputs)
});